import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ScanFace } from "lucide-react";
import { BRAND } from "../lib/brand";
import { useAuth, startLogin } from "../context/AuthContext";

const NAV = [
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/leaderboard", label: "Leaderboard" },
  { to: "/vs", label: "Compare" },
  { to: "/blog", label: "Blog" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-border/60 bg-background/80 backdrop-blur-xl">
      <nav className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <ScanFace className="h-6 w-6 text-primary" />
          <span className="font-display text-xl font-semibold tracking-tight">{BRAND.name}</span>
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm transition hover:text-foreground ${isActive ? "text-foreground" : "text-muted-foreground"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="text-sm text-muted-foreground transition hover:text-foreground">Dashboard</Link>
              <button onClick={() => { logout(); navigate("/"); }} data-testid="logout-btn" className="rounded-md border border-border px-4 py-1.5 text-sm transition hover:border-primary/50">Log out</button>
            </>
          ) : (
            <>
              <button onClick={startLogin} data-testid="nav-login-btn" className="text-sm text-muted-foreground transition hover:text-foreground">Sign in</button>
              <Link to="/" data-testid="nav-cta-btn" className="rounded-md bg-primary px-4 py-1.5 text-sm font-semibold text-primary-foreground transition hover:brightness-110">Scan free</Link>
            </>
          )}
        </div>

        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn" aria-label="Menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-border bg-background md:hidden" data-testid="mobile-menu">
          <div className="container flex flex-col gap-1 py-4">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="rounded-md px-2 py-2.5 text-sm text-muted-foreground hover:bg-secondary hover:text-foreground">{n.label}</Link>
            ))}
            <div className="mt-2 flex flex-col gap-2 border-t border-border pt-3">
              {user ? (
                <>
                  <Link to="/dashboard" onClick={() => setOpen(false)} className="rounded-md px-2 py-2.5 text-sm">Dashboard</Link>
                  <button onClick={() => { logout(); navigate("/"); setOpen(false); }} className="rounded-md border border-border px-4 py-2 text-sm">Log out</button>
                </>
              ) : (
                <button onClick={startLogin} className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground">Sign in</button>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
